export const gpPatientPageNavigation = [
  'demographicInformation',
  'newbornBloodSpotScreening',
  'newbornHearingScreening',
  'examination',
  'childhoodVaccinationHistory',
  'bcgProgramme',
  'neoNatalHepb',
];

export const hvPatientPageNavigation = [
  'demographicInformation',
  'newbornBloodSpotScreening',
  'newbornHearingScreening',
  'examination',
  'childhoodVaccinationHistory',
  'bcgProgramme',
  'neoNatalHepb',
];

export const snPatientPageNavigation = ['demographicInformation', 'childhoodVaccinationHistory', 'reasonNotGiven'];
